import { isValid } from 'clients/Clients';
import { collectEvent } from 'clients/MonitorClient';
import { getProductListByVoucher } from 'clients/ProductClientV2';
import { useEffect, useState } from 'react';
import { useWatch, useFormContext } from 'react-hook-form';
import { MONITORING_COLLECTOR_TYPE } from 'utils/MonitorUtils';

const LIMIT_PER_PAGE = 30;

export const useGetVoucherProducts = ({ filterProduct, limitPerPage = LIMIT_PER_PAGE }: { filterProduct: unknown; limitPerPage?: number }) => {
  const { reset, getFieldState, formState } = useFormContext();
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState<any[]>([]);
  const [totalPage, setTotalPage] = useState(0);

  const page = useWatch({ name: 'page' });
  const search = useWatch({ name: 'search' });

  const isSearchDirty = getFieldState('search').isDirty;
  const isPageDirty = getFieldState('page').isDirty;

  useEffect(() => {
    if (!filterProduct) return;
    if (!isPageDirty && !isSearchDirty && products.length > 0) return;

    setIsLoading(true);

    let offset = +(page - 1) * limitPerPage;
    
    if (isSearchDirty) {
      offset = 0;
      reset({ page: 1, search });
    }

    getProductListByVoucher({
      filter: filterProduct,
      offset: offset,
      limit: limitPerPage,
      text: search,
      queryOption: {
        getWishList: true,
        isReplacePriceAfterVoucher: true,
      },
    })
      .then((res) => {
        if (isValid(res)) {
          setProducts([...res.data]);
          setTotalPage(+(res.total / limitPerPage).toFixed(0));
        } else {
          setTotalPage(0);
          setProducts([]);
        }

        if (search)
          collectEvent(
            MONITORING_COLLECTOR_TYPE.SEARCH,
            {
              content: search,
              host: window?.location?.host || '',
              page: location.pathname,
              status: res.status || 'OK',
            },
            {
              total: +(res?.total || 0),
            } as any,
          );
      })
      .catch(() => {
        setTotalPage(0);
        setProducts([]);
      })
      .finally(() => setIsLoading(false));
  }, [search, page]);

  return {
    isLoading,
    products,
    totalPage,
  };
};

